/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Attribution_MissingInputs */



/**
* | output |
* | --- |
* | "No attribution found — revenue for this customer cannot accrue." |
*
* @param {Partner_Admin_Commission_Attribution_MissingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_attribution_missing = /** @type {((inputs?: Partner_Admin_Commission_Attribution_MissingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Attribution_MissingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Zuordnung gefunden — Umsätze dieses Kunden können nicht auflaufen.")
	return /** @type {LocalizedString} */ ("No attribution found — revenue for this customer cannot accrue.")
});